'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderWrapperStyled = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var propTypes = {
  customBackgroundColor: _propTypes2.default.string,
  behavior: _propTypes2.default.oneOf(['static', 'fixed']),
  width: _propTypes2.default.number,
  size: _propTypes2.default.oneOf(['default', 'blank', 'dense']),
  theme: _propTypes2.default.object
};
var defaultProps = {
  customBackgroundColor: '',
  behavior: 'static',
  size: 'default'
};
/** PROP RECEIVERS */

var sizeProps = function sizeProps(_ref) {
  var size = _ref.size,
      themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var source = size !== 'default' ? theme.reactackle.components.header.header.size[size] : theme.reactackle.components.header.header.size;
  var paddingY = source.paddingY,
      paddingX = source.paddingX,
      minHeight = source.minHeight;
  return '\n    min-height: ' + (0, _reactackleCore.getValueString)(minHeight) + ';\n    padding: ' + (0, _reactackleCore.getValueString)(paddingY) + ' ' + (0, _reactackleCore.getValueString)(paddingX) + ';\n  ';
};

var styleProps = function styleProps(_ref2) {
  var themeFromProvider = _ref2.theme,
      customBackgroundColor = _ref2.customBackgroundColor;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var backgroundColor = theme.reactackle.components.header.header.backgroundColor,
      headerBackground = customBackgroundColor || backgroundColor;
  return '\n    background-color: ' + headerBackground + ';\n  ';
};

var modeProps = function modeProps(_ref3) {
  var behavior = _ref3.behavior;
  var styles = null;

  if (behavior === 'fixed') {
    styles = '\n      top: 0;\n      position: fixed;\n      will-change: transform;\n    ';
  }

  return styles;
};
/** STYLES */


var HeaderWrapperStyled = exports.HeaderWrapperStyled = _styledComponents2.default.div.withConfig({
  displayName: 'HeaderWrapperStyled'
})(['display:flex;align-items:stretch;flex-grow:1;z-index:1;transform:translateZ(0);', ';', ';', ';', ';'], (0, _reactackleCore.transition)('transform, top, height', '150ms'), sizeProps, styleProps, modeProps);

HeaderWrapperStyled.propTypes = propTypes;
HeaderWrapperStyled.defaultProps = defaultProps;
HeaderWrapperStyled.displayName = 'HeaderWrapperStyled';